import React, { useEffect, useRef, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
    root: {
        width: 300,
        overflow: "hidden",
        position: "relative",
        whiteSpace: "nowrap",
    },
    scrollTrack: {
        display: "inline-flex",
        animation: "$scrollLeft linear infinite",
        willChange: "transform",
    },
    scrollItem: {
        flexShrink: 0,
        paddingRight: 50,
    },
    masked: {
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
    },
    "@keyframes scrollLeft": {
        "0%": { transform: "translateX(0)" },
        "100%": { transform: "translateX(-50%)" },
    },
}));

export default function ScrollText({
       text,
       children,
       width = 300,
       speed = 12,
       hoverBehavior = "pause",
}) {
    const classes = useStyles();
    const containerRef = useRef(null);
    const textRef = useRef(null);
    const [scrollNeeded, setScrollNeeded] = useState(false);
    const [hovered, setHovered] = useState(false);

    useEffect(() => {
        if (containerRef.current && textRef.current) {
            const isOverflowing =
                textRef.current.scrollWidth > containerRef.current.clientWidth;
            setScrollNeeded(isOverflowing);
        }
    }, [text, children]);

    const duration = () => {
        if (!containerRef.current || !textRef.current) return `${speed}s`;
        const distance = textRef.current.scrollWidth;
        return `${distance / speed}s`;
    };

    const getPlayState = () => {
        if (!scrollNeeded) return "paused";

        if (hoverBehavior === "pause") {
            return hovered ? "paused" : "running";
        }
        if (hoverBehavior === "start") {
            return hovered ? "running" : "paused";
        }
        return "running";
    };

    const handleMouseEnter = () => {
        setHovered(true);

        if (hoverBehavior === "start") {
            const track = containerRef.current?.querySelector(`.${classes.scrollTrack}`);
            if (track) {
                track.style.removeProperty("transform");
            }
        }
    };


    const handleMouseLeave = () => {
        setHovered(false);
        if (hoverBehavior === "start") {
            const track = containerRef.current?.querySelector(
                `.${classes.scrollTrack}`
            );
            if (track) {
                track.style.setProperty("transform", "translateX(0)", "important");
            }
        }
    };

    const isRunning = getPlayState() === "running";

    return (
        <div
            className={classes.root}
            style={{ width }}
            ref={containerRef}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <div
                className={`${classes.scrollTrack} ${!isRunning ? classes.masked : ""}`}
                style={{
                    animationDuration: duration(),
                    animationPlayState: getPlayState(),
                }}
            >
                <div className={classes.scrollItem} ref={textRef}>
                    {children || text}
                </div>
                <div className={classes.scrollItem}>{children || text}</div>
            </div>
        </div>
    );
}
